/* tslint:disable */
/* eslint-disable */
export enum PeriodEnum {
  IMMEDIATELLY = 'Immediatelly',
  MONTH_3 = 'Month_3',
  MONTH_3_6 = 'Month_3_6',
  MONTH_6_9 = 'Month_6_9',
  MONTH_9_12 = 'Month_9_12',
  NEXT_YEAR = 'Next_Year'
}
